import { useEffect } from 'react';
import { useWhiteLabel } from '../WhiteLabelProvider';
import {
  createDynamicThemes,
  applyCssCustomProperties,
  getCurrentThemeMode,
} from '../dynamicThemeGenerator';

export const useApplyWhiteLabel = () => {
  const whiteLabel = useWhiteLabel();

  useEffect(() => {
    if (!whiteLabel) return;

    // Update document title
    document.title = whiteLabel.brandName;

    // Update favicon
    let favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = whiteLabel.faviconUrl;

    // Apply dynamic themes and CSS properties
    const themes = createDynamicThemes(whiteLabel);
    const currentMode = getCurrentThemeMode();
    const currentTheme = themes[currentMode];

    applyCssCustomProperties(whiteLabel, currentTheme);

    // Legacy CSS properties for backward compatibility
    const root = document.documentElement;
    if (whiteLabel.primaryColor) {
      root.style.setProperty('--color-primary', whiteLabel.primaryColor);
    }
    if (whiteLabel.secondaryColor) {
      root.style.setProperty('--color-secondary', whiteLabel.secondaryColor);
    }
  }, [whiteLabel]);
};
